import { useCallback, useMemo, useState } from "react";

// close() keeps `data` for F7's close animation. Never pass open as onClick
// directly, or the click event becomes `data`.
export const usePopup = (initialData = null) => {
  const [state, setState] = useState({ opened: false, data: initialData });

  const open = useCallback(
    (data = null) => setState({ opened: true, data }),
    [],
  );
  const close = useCallback(
    () =>
      setState((current) =>
        current.opened ? { ...current, opened: false } : current,
      ),
    [],
  );

  return useMemo(
    () => ({ opened: state.opened, data: state.data, open, close }),
    [state, open, close],
  );
};
